// Pago por Lavados — one row per finished wash logged in the Check app in the
// period (by when the wash started, Mexico City time). "Pago" counts only
// washes approved by the AI or by a manager; flagged and rejected ones show
// their price but pay 0 until approved. Washers split the week's pay, so the
// total per Sucursal is what gets shared; Lavador is who started the wash.
import supabase from "../../../supabase-client";
import { levelsText, STATUS, PAID_STATUSES, fmtMoney, mxDate } from "../../Washes/washUtil";

export const washPayReport = {
  id: "wash-pay",
  title: "Pago por Lavados",
  description:
    "Lavados por lavador en el periodo: tipo, duración, calificación de IA y pago (solo aprobados).",
  category: "Operaciones",
  filters: [
    { type: "daterange", fromKey: "from", toKey: "to", label: "Periodo", required: true },
    { type: "facet", key: "sucursal", label: "Sucursal", column: "sucursal" },
    { type: "facet", key: "lavador", label: "Lavador", column: "lavador" },
    { type: "facet", key: "estatus", label: "Estatus", column: "estatus" },
    { type: "facet", key: "tipo", label: "Tipo", column: "tipo" },
  ],
  summary: [
    { type: "count", label: "Lavados" },
    { type: "sum", label: "Pago total (aprobados)", valueKey: "pago", valueFormat: fmtMoney },
    { type: "sum", label: "Por revisar", valueKey: "por_revisar", valueFormat: (v) => String(v || 0) },
    { type: "groupBy", label: "Por sucursal", key: "sucursal", valueKey: "pago", valueFormat: fmtMoney },
    { type: "groupBy", label: "Por lavador", key: "lavador" },
    { type: "groupBy", label: "Por día", key: "fecha" },
  ],
  columns: [
    { key: "fecha", label: "Fecha" },
    { key: "sucursal", label: "Sucursal" },
    { key: "lavador", label: "Lavador", width: 160, truncate: true },
    { key: "placa", label: "Placa" },
    { key: "tipo", label: "Tipo", width: 180 },
    { key: "duracion", label: "Duración (min)", exportType: "integer" },
    { key: "ia", label: "IA", format: (v) => (v == null ? "" : `${v}/10`) },
    { key: "estatus", label: "Estatus" },
    { key: "precio", label: "Precio", format: fmtMoney, exportType: "currency" },
    { key: "pago", label: "Pago", format: fmtMoney, exportType: "currency" },
    { key: "id", label: "Lavado" },
  ],
  async fetch({ from, to }) {
    if (!from || !to) throw new Error("Seleccionar periodo");
    const { data, error } = await supabase
      .from("car_washes")
      .select(
        "id, levels, price_total, started_at, duration_min, ai_score, review_status, branch:branches(name), car:cars(plate), staff:users!staff_id(name)"
      )
      .not("review_status", "in", "(open,cancelled)")
      .gte("started_at", `${from}T00:00:00-06:00`)
      .lte("started_at", `${to}T23:59:59.999-06:00`)
      .order("started_at");
    if (error) throw error;
    return (data || []).map((w) => ({
      id: w.id,
      fecha: mxDate(w.started_at),
      sucursal: w.branch?.name || "Sin sucursal",
      lavador: w.staff?.name || "Sin lavador",
      placa: w.car?.plate || "",
      tipo: levelsText(w.levels),
      duracion: w.duration_min,
      ia: w.ai_score,
      estatus: STATUS[w.review_status]?.label || w.review_status,
      precio: Number(w.price_total) || 0,
      pago: PAID_STATUSES.includes(w.review_status) ? Number(w.price_total) || 0 : 0,
      por_revisar: w.review_status === "flagged" ? 1 : 0,
    }));
  },
};
